import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from '@/services/base.service';
import { Sponsor } from '@/models/sponsor.model';

class SponsorService extends BaseService {
  private url: string = '/api/sponsor';

  private cached: Sponsor[] = [];

  constructor() {
    super();
  }

  public new(): Sponsor {
    return {
      id: -1,
      name: '',
      website: '',
      main: false,
      lottery: false,
      contribution: '',
    };
  }

  public async getList(): Promise<DataResponse<Sponsor[]>> {
    let res: any = {
      status: Status.Ok,
      data: [],
    };
    if (!this.hasCache()) {
      res = await this.$http.get<Sponsor[]>(`${this.url}`);
      this.setCache(res.data);
    }
    return {
      status: res.status === Status.Ok,
      data: this.getCache(),
    };
  }

  public async get(id: number): Promise<DataResponse<Sponsor>> {
    const res = await this.$http.get<Sponsor>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async put(message: Sponsor): Promise<DataResponse<Sponsor>> {
    const res = await this.$http.put<Sponsor>(
      `${this.url}/${message.id}`,
      message,
    );
    this.clearCache();
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async post(message: Sponsor): Promise<DataResponse<Sponsor>> {
    const res = await this.$http.post<Sponsor>(this.url, message);
    this.clearCache();
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);
    this.clearCache();
    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }

  private getCache(): Sponsor[] {
    return this.cached;
  }

  private setCache(list: Sponsor[]): void {
    this.cached = list;
  }

  private hasCache(): boolean {
    return this.cached.length !== 0;
  }

  private clearCache(): void {
    this.setCache([]);
  }
}

export default new SponsorService();
